export default "__VITE_ASSET__8Qf8H9s9__"